
import { MY_ACCOUNT, NAVIGATION, WISHLIST_SAVE, NEWEST_TO_OLDEST, OLDEST_TO_NEWEST, LISTS } from "@/components/MyFavorites/v1/MyList/constant"
import { MY_LISTS_PAGE_PATH, PRODUCT_BEST_SELLERS } from "@/constants/routes" 
  

const pushToAdobeDataLayer = (eventInfo, listInfo) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  page.category.pageType = "my list"
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    ...(listInfo ? { listInfo } : {}),
    page,
  })
}

export const dataLayerViewListButton = (
  myListTitle,
  viewListCTATitle,
  listName,
  listInfo,
  idView
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const viewListCTAHeading = viewListCTATitle?.toLowerCase()
  const url = MY_LISTS_PAGE_PATH
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${viewListCTAHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${viewListCTAHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${viewListCTAHeading}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}:${listName}`,
    internalLinkURL: `${window.location.origin}${url}${idView}`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}`,
  }
  pushToAdobeDataLayer(eventInfo, listInfo)
}

export const dataLayerShopBestSellerButton = (
  myListTitle,
  shopBestSellerCTATitle,
  listName,
  listInfo,

) => {
  const myListHeading = myListTitle?.toLowerCase()
  const shopBestSellerCTAHeading = shopBestSellerCTATitle?.toLowerCase()
  const urlP = PRODUCT_BEST_SELLERS
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${shopBestSellerCTAHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${shopBestSellerCTAHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${shopBestSellerCTAHeading}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}:${listName}`,
    internalLinkURL: `${window.location.origin}${urlP}`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}`,
  }
  pushToAdobeDataLayer(eventInfo, listInfo)
}

export const dataLayerDeleteListButton = (
  myListTitle,
  deleteListTitle,
  listName,
  listInfo,
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const deleteListHeading = deleteListTitle?.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${deleteListHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${deleteListHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${deleteListHeading}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}:${listName}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}`,
  }
  pushToAdobeDataLayer(eventInfo, listInfo)
}

export const dataLayerCreateNewMyListButton = (
  myListTitle,
  createNewListTitle
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const createNewListHeading = createNewListTitle?.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${createNewListHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${createNewListHeading}`,
    eventStatus: "n/a",
    eventType: `${WISHLIST_SAVE}`,
    internalLinkName: `${createNewListHeading}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}`,
  }
  pushToAdobeDataLayer(eventInfo)
}

export const dataLayerlistTab = (
  myListTitle,
  tabListTitle
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const listTabHeading = tabListTitle?.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${listTabHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${listTabHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${listTabHeading}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}:${listTabHeading}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}`,
  }
  pushToAdobeDataLayer(eventInfo)
}

export const dataLayerMediaTab = (
  myListTitle,
  mediaTabTitle
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const mediaTabHeading = mediaTabTitle?.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${mediaTabHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${mediaTabHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${mediaTabHeading}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}${mediaTabHeading}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}`,
  }
  pushToAdobeDataLayer(eventInfo)
}

export const dataLayerNewestToOldest = (
  myListTitle,
  sortByTitle,
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const sortByHeading = sortByTitle?.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${LISTS}:${sortByHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${LISTS}:${sortByHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${NEWEST_TO_OLDEST}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}:${LISTS}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}:${NEWEST_TO_OLDEST}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}:${LISTS}`,
  }
  pushToAdobeDataLayer(eventInfo)
}

export const dataLayerOldestToNewest = (
  myListTitle,
  sortByTitle,
) => {
  const myListHeading = myListTitle?.toLowerCase()
  const sortByHeading = sortByTitle?.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true", 
    eventAction: `${MY_ACCOUNT}:${myListHeading}:${LISTS}:${sortByHeading}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${myListHeading}:${LISTS}:${sortByHeading}`,
    eventStatus: "n/a",
    eventType: `${NAVIGATION}`,
    internalLinkName: `${OLDEST_TO_NEWEST}`,
    internalLinkPosition: `${MY_ACCOUNT}:${myListHeading}:${LISTS}`,
    internalLinkType: `${MY_ACCOUNT}:${myListHeading}:${OLDEST_TO_NEWEST}`,
    internalLinkURL: `n/a`,
    internalLinkZoneName: `${MY_ACCOUNT}:${myListHeading}:${LISTS}`,
  }
  pushToAdobeDataLayer(eventInfo)
}

